import { useEffect, useRef, useState } from 'react';

import { getDashboardTargetSlice } from '../../../api/climateTargetApi';

const isCanceled = error => (
  error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError'
);

/** Load the composed dashboard target slice for one fiscal year (P2). */
export default function useClimateActionDashboardSlice(selectedYear) {
  const [slice, setSlice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const sequenceRef = useRef(0);

  useEffect(() => {
    const controller = new AbortController();
    const sequence = sequenceRef.current + 1;
    sequenceRef.current = sequence;
    setLoading(true);
    setError(null);

    getDashboardTargetSlice(selectedYear, { signal: controller.signal })
      .then((payload) => {
        if (sequenceRef.current === sequence) setSlice(payload);
      })
      .catch((loadError) => {
        if (sequenceRef.current === sequence && !isCanceled(loadError)) {
          setError(loadError);
        }
      })
      .finally(() => {
        if (sequenceRef.current === sequence) setLoading(false);
      });

    return () => controller.abort();
  }, [selectedYear]);

  return { slice, loading, error };
}